import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../../../page/templates/templates.component';
@Component({
  selector: 'app-add-template-dialog',
  templateUrl: './add-template-dialog.component.html',
  styleUrls: ['./add-template-dialog.component.scss'],
  standalone: false,  // NOSONAR
})
export class AddTemplateDialogComponent implements OnInit {
  action;
  templateDescription;
  // pageName;
  enableError: boolean = false;
  constructor(public dialogRef: MatDialogRef<AddTemplateDialogComponent>) {
    this.action = 'AddCell';
  }
  ngOnInit(): void { // NOSONAR
    //  do something 
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  close(): void {
    this.dialogRef.close();
  }
  public saveClick() {
    if (this.templateDescription == '' || this.templateDescription == null || this.templateDescription == undefined || this.templateDescription.trim().length == 0) {  // NOSONAR
      this.enableError = true;
    }
    else {
      this.dialogRef.close({ event: this.action, data: this.templateDescription });
    }
  }
}
